// Shared view-model helpers for the Shopify_Logs module.
//
// These were originally defined inline in Logs.jsx. They're extracted here so
// both the org-wide Logs table and the per-record Journey timeline share a
// single source of truth for the field-name → camelCase mapping, the status
// colour palette, and the date formatters.

import { EXTENSION_IDENTIFIER } from "../../../config/serviceConstant";

const EXT = EXTENSION_IDENTIFIER;

/** Extract the shop domain from a Shopify admin URL. */
export const shopFromUrl = (url) => {
  if (!url) return "";
  try {
    return new URL(url).hostname;
  } catch {
    return "";
  }
};

/**
 * Normalise a raw CRM record into a flat object.
 * Uses the actual Zoho CRM field API names from the Shopify_Logs module.
 */
export const normaliseLog = (raw) => {
  const name = raw?.Name || "";
  const module = raw?.[`${EXT}__Module`] || "";
  const moduleRecordId = raw?.[`${EXT}__Module_Record_ID`] || "";
  const shopifyModule = raw?.[`${EXT}__Shopify_Module`] || "";
  const shopifyRecordId = raw?.[`${EXT}__Shopify_Record_ID`] || "";
  const fromPlatform = raw?.[`${EXT}__From_Platform`] || "";
  const toPlatform = raw?.[`${EXT}__To_Platform`] || "";
  const reason = raw?.[`${EXT}__Reason`] || "";
  const source = raw?.[`${EXT}__Source`] || "Shopify Webhook";
  const settingId = raw?.[`${EXT}__Setting_ID`] || "";
  const requestBody = raw?.[`${EXT}__Request_Body`] || "";
  const shopifyUrl = raw?.[`${EXT}__Shopify_URL`] || "";
  const status = raw?.[`${EXT}__Status`] || "";
  const createdTime = raw?.Created_Time || "";

  return {
    id: raw?.id || raw?.Id || "",
    name,
    module,
    moduleRecordId,
    shopifyModule,
    shopifyRecordId,
    fromPlatform,
    toPlatform,
    reason,
    source,
    settingId,
    requestBody,
    shopifyUrl,
    shop: shopFromUrl(shopifyUrl),
    status,
    createdTime,
  };
};

// ── Date formatters ──

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return isNaN(d) ? iso : d.toLocaleDateString("en-AU", { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return iso;
  }
};

export const fmtTime = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return isNaN(d) ? "" : d.toLocaleTimeString("en-AU", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false });
  } catch {
    return "";
  }
};

export const fmtDateKey = (iso) => {
  if (!iso) return "Unknown";
  try {
    const d = new Date(iso);
    return isNaN(d) ? "Unknown" : d.toLocaleDateString("en-AU", { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return "Unknown";
  }
};

// ── Status chip colour map ──

export const STATUS_COLORS = {
  Failed:   { bg: "#fef2f2", color: "#b91c1c", border: "#fca5a5" },
  Error:    { bg: "#fef2f2", color: "#b91c1c", border: "#fca5a5" },
  Success:  { bg: "#f0fdf4", color: "#15803d", border: "#86efac" },
  Pending:  { bg: "#fffbeb", color: "#a16207", border: "#fde68a" },
  Retrying: { bg: "#eff6ff", color: "#1d4ed8", border: "#93c5fd" },
};
export const DEFAULT_STATUS = { bg: "#f4f4f5", color: "#3f3f46", border: "#d4d4d8" };
